// extracted by mini-css-extract-plugin
export default {"wrapper":"SomeoneSpecial_wrapper__Y9DpF","input_wrapper":"SomeoneSpecial_input_wrapper__WDszh","error_msg":"SomeoneSpecial_error_msg__zdYC4"};